var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form',{attrs:{"form":_vm.form}},[_c('a-form-item',{attrs:{"label":"状态","labelCol":_vm.labelCol,"wrapperCol":_vm.wrapperCol}},[_c('a-radio-group',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'state',
        {
          rules: [{ required: true, message: '是否废弃' }],
          initialValue: 2
        }
      ]),expression:"[\n        'state',\n        {\n          rules: [{ required: true, message: '是否废弃' }],\n          initialValue: 2\n        }\n      ]"}],attrs:{"name":"state"}},[_c('a-radio',{attrs:{"value":1}},[_vm._v(" 作废 ")]),_c('a-radio',{attrs:{"value":2}},[_vm._v(" 取消作废 ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }